var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"section has-padding-top-15"},[_c('div',{staticClass:"carge"},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t("common.buyCoins")))]),_c('charge-account')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }